import { FC } from 'react'
import {
  Route,
  Redirect,
} from 'react-router-dom'

import CONFIG from '../../config'
import { formData } from '../services'

interface IRouteSolemProps {
  component: any,
  path?: string,
  exact?: boolean
}

let redirectTo = CONFIG.ROUTES.AUTH.REGISTER.HOME

const RouteSolem: FC<IRouteSolemProps> = ({ component, path, ...rest }) => {

  const getRoute = () => <Route component={component} path={path} {...rest} />

  if(formData.pageRutValid()) return getRoute()

  console.log('TEST RouteSolem redirectTo:', redirectTo);
  console.log('TEST RouteSolem pageRutValid:', formData.pageRutValid());

  return <Redirect to={redirectTo} {...rest} />
}

export { RouteSolem }